import { getCurrentInstance, computed, reactive } from 'vue';
import { ModuleFundStructure } from '@/stores/moduleConst';
import { useStore } from 'vuex';

// Combo grid Tài khoản nợ, có
export const useCacheFundStructureComboConfig = () => {
  const { proxy } = getCurrentInstance();

  const store = useStore();

  const fundStructureCombo = computed(() => {
    const fundStructures = store.getters[`${ModuleFundStructure}/items`];
    return fundStructures.filter(x => !x.inactive && !x.is_parent);
  });

  // config columns combo
  const cacheFundStructureComboConfig = reactive({
    data: fundStructureCombo,
    columns: [
      {
        title: 'Mã cơ cấu vốn',
        dataField: 'fund_structure_code',
        width: 120,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên cơ cấu vốn',
        dataField: 'fund_structure_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 480,
      },
    ],
    displayField: 'fund_structure_name',
    valueField: 'fund_structure_id',
    queryMode: 'local',
    dropdownWidth: 600,
    quickSearch: 'LocalQuickSearchPopup',
    quickSearchParam: {
      idField: 'func_structure_id',
      titleSearch: 'Tìm nhanh cơ cấu vốn',
    },
  });

  return {
    cacheFundStructureComboConfig,
  };
};
